import MyPools from './MyPools.vue'

export default MyPools
